import Cookies from 'js-cookie';

export const setStorageItem = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    if (key === 'AuthenticationStore') {
      setStoredSpoilerControlDetails(value);
    }
  } catch(err) {
    console.log(`setStorageItem error with ${key}`, err);
  }
}

export const getStorageItem = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key) || '""');
  } catch (err) {
    console.log(`getStorageItem error with ${key}`, err);
  }
}

export const removeStorageItem = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    console.log(`removeStorageItem error with ${key}`, err);
  }
}

export const clearStorageItem = () => {
  try {
    localStorage.removeItem("AuthenticationStore");
    localStorage.removeItem("MonetizationStore");
    localStorage.removeItem("CheckoutStore");
    localStorage.removeItem("routeState");
    localStorage.removeItem("isRedirected");
    localStorage.removeItem("transactionData");
    localStorage.removeItem("transactionUserList");
    localStorage.removeItem("SseStore");
    localStorage.removeItem("adobeConfig");
    localStorage.removeItem("BulkAssetMap");
    localStorage.removeItem("bulkContentMap");
    localStorage.removeItem("bulkEnitlementMap")
    localStorage.removeItem("nbaAuthConfig");
    localStorage.removeItem("nbaUserInfo");
    // JS-readable access token set by storeNbaTokens — must not outlive VL session clear
    Cookies.remove('nbaAuthToken');
    sessionStorage.removeItem("spoilerControlDetails");
    sessionStorage.removeItem("showDetailsEnabled");
    sessionStorage.removeItem('isRokuBox');
		sessionStorage.removeItem('tveRokuRegCode');
    sessionStorage.removeItem('toolboxAuthZResponse');
  } catch (err) {
    console.log(`clearStorageItem error`, err);
  }
}

export const setStoredSpoilerControlDetails = (store) => {
    // const store = getStorageItem('AuthenticationStore')
    const spoilerControlData = store?.user?.profiles?.[0]?.spoilerControl;
    if(spoilerControlData){
        sessionStorage.setItem("spoilerControlDetails", JSON.stringify(spoilerControlData));
    }
}